// AUTO-GENERATED FILE !! DO NOT EDIT !!
import { PERMISSIONS } from '@/constants/permissions'
import { ROLES } from '@/constants/roles'

export const LINKED_PERMISSIONS = {
  [ROLES.ASSET_MANAGEMENT]: [],
  [ROLES.ASSET_MANAGEMENT_CONTRIBUTOR]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.CREATE_INSTRUMENTS,
    PERMISSIONS.READ_ADMIN_FUNDS,
    PERMISSIONS.READ_DAILY_COMPOSITION,
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FLOWS,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_INSTRUMENTS,
    PERMISSIONS.READ_MARKET_SUMMARY,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.WRITE_DATA_PRESENCE,
    PERMISSIONS.WRITE_FIXED_INCOME,
    PERMISSIONS.WRITE_IC_GUIDELINES,
    PERMISSIONS.WRITE_MARKET_SUMMARY,
    PERMISSIONS.WRITE_TRADING_DATA,
    PERMISSIONS.WRITE_UPLOAD_TRACK,
  ],
  [ROLES.ASSET_MANAGEMENT_VIEWER]: [
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_INSTRUMENTS,
    PERMISSIONS.READ_MARKET_SUMMARY,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_UPLOAD_TRACK,
  ],
  [ROLES.DATA_ENGINEER]: [PERMISSIONS.READ_LOGS],
  [ROLES.DEVELOPER]: [],
  [ROLES.FLOW]: [],
  [ROLES.FLOW_CONTRIBUTOR]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.CREATE_INSTRUMENTS,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
    PERMISSIONS.WRITE_FACTSHEETS,
    PERMISSIONS.WRITE_FLOW_POSMON,
    PERMISSIONS.WRITE_PRICING_INTERFACE,
    PERMISSIONS.WRITE_SMARTRADE_TRADES,
    PERMISSIONS.WRITE_WEBSITE,
  ],
  [ROLES.FLOW_VIEWER]: [
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_WEBSITE,
  ],
  [ROLES.FORTEM_EMPLOYEE]: [],
  [ROLES.IC_COMMITTEE]: [PERMISSIONS.READ_IC_GUIDELINES, PERMISSIONS.READ_IC_REPORT],
  [ROLES.MANAGEMENT]: [PERMISSIONS.ACCESS_V1],
  [ROLES.OPERATIONS]: [],
  [ROLES.OPERATIONS_CONTRIBUTOR]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.APPROVE_PNL_VALIDATION,
    PERMISSIONS.CREATE_INSTRUMENTS,
    PERMISSIONS.READ_ADMIN_FUNDS,
    PERMISSIONS.READ_AUTOMATED_NAV,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_DAILY_COMPOSITION,
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FEEDS,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_GUIDELINES_STATUS,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_INSTRUMENTS,
    PERMISSIONS.READ_MAPPINGS,
    PERMISSIONS.READ_MARKETDATA,
    PERMISSIONS.READ_MARKET_SUMMARY,
    PERMISSIONS.READ_MONTHLY_ROLL,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_NT_HEDGING_FXFWD,
    PERMISSIONS.READ_OPERATIONS,
    PERMISSIONS.READ_PNL_VALIDATION,
    PERMISSIONS.READ_POSITIONS_PNL,
    PERMISSIONS.READ_PRICE_VALIDATION,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_CALIBRATION,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_TX_REPORTING,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
    PERMISSIONS.RUN_DATA_PRESENCE,
    PERMISSIONS.RUN_IC_GUIDELINES,
    PERMISSIONS.RUN_MARKETDATA_JOBS,
    PERMISSIONS.RUN_RISK_CALIBRATION,
    PERMISSIONS.WRITE_ADMIN_FUNDS,
    PERMISSIONS.WRITE_CLIENT_PRICING,
    PERMISSIONS.WRITE_CLOUD_PRICING,
    PERMISSIONS.WRITE_DAILY_COMPOSITION,
    PERMISSIONS.WRITE_DATA_PRESENCE,
    PERMISSIONS.WRITE_FACTSHEETS,
    PERMISSIONS.WRITE_FIXED_INCOME,
    PERMISSIONS.WRITE_FLOW_POSMON,
    PERMISSIONS.WRITE_MAPPINGS,
  ],
  [ROLES.OPERATIONS_VIEWER]: [
    PERMISSIONS.READ_ADMIN_FUNDS,
    PERMISSIONS.READ_AUTOMATED_NAV,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_DAILY_COMPOSITION,
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FEEDS,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_GUIDELINES_STATUS,
    PERMISSIONS.READ_INSTRUMENTS,
    PERMISSIONS.READ_MAPPINGS,
    PERMISSIONS.READ_MARKET_SUMMARY,
    PERMISSIONS.READ_MONTHLY_ROLL,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_NT_HEDGING_FXFWD,
    PERMISSIONS.READ_OPERATIONS,
    PERMISSIONS.READ_PNL_VALIDATION,
    PERMISSIONS.READ_POSITIONS_PNL,
    PERMISSIONS.READ_PRICE_VALIDATION,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_CALIBRATION,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_TX_REPORTING,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
  ],
  [ROLES.READ_ONLY_ADMIN]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.READ_ADMIN_FUNDS,
    PERMISSIONS.READ_AUTOMATED_NAV,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_DAILY_COMPOSITION,
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FEEDS,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_FLOWS,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_GUIDELINES_STATUS,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_INSTRUMENTS,
    PERMISSIONS.READ_LOGS,
    PERMISSIONS.READ_MAPPINGS,
    PERMISSIONS.READ_MARKETDATA,
    PERMISSIONS.READ_MARKET_SUMMARY,
    PERMISSIONS.READ_MONTHLY_ROLL,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_NT_HEDGING_FXFWD,
    PERMISSIONS.READ_OPERATIONS,
    PERMISSIONS.READ_PERF_REPORT,
    PERMISSIONS.READ_PNL_VALIDATION,
    PERMISSIONS.READ_POSITIONS_PNL,
    PERMISSIONS.READ_PRICE_VALIDATION,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_CALIBRATION,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_SCHEDULED_TASKS,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_TX_REPORTING,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
  ],
  [ROLES.ROLETEST]: [],
  [ROLES.SALES]: [],
  [ROLES.SALES_CONTRIBUTOR]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_PERF_REPORT,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
  ],
  [ROLES.SALES_VIEWER]: [
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_PERF_REPORT,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
  ],
  [ROLES.TRADING]: [],
  [ROLES.TRADING_CONTRIBUTOR]: [
    PERMISSIONS.ACCESS_V1,
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_DATA_PRESENCE,
    PERMISSIONS.READ_FIXED_INCOME,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_FUND_ATTRIBUTIONS,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_RISK_PREMIA,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
    PERMISSIONS.WRITE_SMARTRADE_DATA,
    PERMISSIONS.WRITE_SMARTRADE_TRADES,
    PERMISSIONS.WRITE_TRADES,
    PERMISSIONS.WRITE_TRADING_DATA,
  ],
  [ROLES.TRADING_VIEWER]: [
    PERMISSIONS.READ_CLIENT_PRICING,
    PERMISSIONS.READ_FLOW_POSMON,
    PERMISSIONS.READ_IC_GUIDELINES,
    PERMISSIONS.READ_IC_REPORT,
    PERMISSIONS.READ_NAV_UPDATE,
    PERMISSIONS.READ_PRICING_INTERFACE,
    PERMISSIONS.READ_RFQ_DATA,
    PERMISSIONS.READ_SMARTRADE_DATA,
    PERMISSIONS.READ_SMARTRADE_TRADES,
    PERMISSIONS.READ_TIME_SERIES,
    PERMISSIONS.READ_TRADES,
    PERMISSIONS.READ_UPLOAD_TRACK,
    PERMISSIONS.READ_WEBSITE,
  ],
} as const
